var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweepCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    viewBox: "349.57 353.25 305.96 305.96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000169556119848147629700000002218387633290861456_);}\r\n\t.st2{fill:url(#SVGID_00000084501056844311967500000008505432261613851780_);}\r\n\t.st3{fill:url(#SVGID_00000003082481403244535350000014573174118050522245_);}\r\n\t.st4{fill:#155929;}\r\n\t.st5{fill:url(#SVGID_00000155128605392390094850000016649604927653815943_);}\r\n\t.st6{fill:url(#SVGID_00000031915683654005395270000008346418338762211000_);}\r\n\t.st7{fill:url(#SVGID_00000039099060628208079190000012008235350071113397_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 672.3428,
    y1: 506.228,
    x2: 279.0949,
    y2: 506.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333333"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M655.53,506.23c0,84.49-68.49,152.98-152.98,152.98c-84.49,0-152.98-68.49-152.98-152.98   c0-84.49,68.49-152.98,152.98-152.98C587.04,353.25,655.53,421.74,655.53,506.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158014013123709328770000003096217625673897114_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.5508,
    y1: 571.9678,
    x2: 502.5508,
    y2: 332.8862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#37B34A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#009345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158014013123709328770000003096217625673897114_)"
    },
    d: "M502.55,368.93   c-74.75,0-135.34,60.6-135.34,135.34c0,74.75,60.6,135.34,135.34,135.34c74.75,0,135.34-60.6,135.34-135.34   C637.89,429.52,577.3,368.93,502.55,368.93z M371.13,504.27c0-72.47,58.96-131.42,131.43-131.42   c72.47,0,131.42,58.96,131.42,131.42c0,72.47-58.96,131.42-131.42,131.42C430.09,635.69,371.13,576.73,371.13,504.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164503094181983778290000004082718340074137001_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.6418,
    y1: 603.5234,
    x2: 503.6418,
    y2: 501.6199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164503094181983778290000004082718340074137001_)"
    },
    d: "M438.01,536.48   c-22.55,0-44.29-2.99-64.7-8.53c11.19,61.19,64.86,107.74,129.24,107.74c72.47,0,131.42-58.96,131.42-131.42   c0-20.09-4.55-39.13-12.64-56.18C583.68,501.09,515.67,536.48,438.01,536.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078737817789375269580000010289338333140886678_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.2316,
    y1: 511.418,
    x2: 496.2316,
    y2: 378.1593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666666"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078737817789375269580000010289338333140886678_)"
    },
    d: "M621.34,448.09   c-21.11-44.44-66.41-75.25-118.78-75.25c-72.47,0-131.43,58.96-131.43,131.42c0,8.09,0.77,16,2.18,23.69   c20.42,5.53,42.15,8.53,64.7,8.53C515.67,536.48,583.68,501.09,621.34,448.09z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 387.531 525.829 L 403.373 524.444 Q 404.499 533.967 408.611 540.071 Q 412.723 546.174 421.38 549.94 Q 430.038 553.706 440.859 553.706 Q 450.469 553.706 457.827 550.849 Q 465.186 547.992 468.779 543.014 Q 472.371 538.036 472.371 532.149 Q 472.371 526.176 468.909 521.717 Q 465.446 517.259 457.481 514.229 Q 452.373 512.238 434.886 508.039 Q 417.398 503.84 410.386 500.117 Q 401.296 495.356 396.837 488.3 Q 392.379 481.245 392.379 472.501 Q 392.379 462.891 397.833 454.537 Q 403.287 446.183 413.762 441.854 Q 424.237 437.526 437.05 437.526 Q 451.161 437.526 461.939 442.071 Q 472.718 446.616 478.518 455.446 Q 484.318 464.277 484.751 475.444 L 468.649 476.656 Q 467.35 464.623 459.862 458.476 Q 452.373 452.33 437.743 452.33 Q 422.506 452.33 415.537 457.914 Q 408.568 463.497 408.568 471.375 Q 408.568 478.215 413.502 482.63 Q 418.35 487.045 438.825 491.677 Q 459.299 496.308 466.917 499.771 Q 477.999 504.879 483.28 512.714 Q 488.56 520.549 488.56 530.764 Q 488.56 540.893 482.76 549.853 Q 476.96 558.813 466.095 563.791 Q 455.23 568.769 441.638 568.769 Q 424.41 568.769 412.766 563.748 Q 401.122 558.727 394.5 548.641 Q 387.877 538.556 387.531 525.829 Z M 602.052 522.107 L 618.848 526.349 Q 613.567 547.04 599.845 557.904 Q 586.123 568.769 566.298 568.769 Q 545.781 568.769 532.925 560.415 Q 520.069 552.061 513.359 536.218 Q 506.65 520.375 506.65 502.195 Q 506.65 482.37 514.225 467.61 Q 521.8 452.849 535.781 445.187 Q 549.763 437.526 566.558 437.526 Q 585.604 437.526 598.59 447.222 Q 611.575 456.918 616.683 474.492 L 600.148 478.388 Q 595.733 464.536 587.335 458.217 Q 578.938 451.897 566.212 451.897 Q 551.581 451.897 541.755 458.909 Q 531.929 465.921 527.947 477.739 Q 523.964 489.556 523.964 502.109 Q 523.964 518.298 528.683 530.374 Q 533.401 542.451 543.357 548.425 Q 553.312 554.398 564.913 554.398 Q 579.024 554.398 588.807 546.26 Q 598.59 538.123 602.052 522.107 Z",
    style: {
      whiteSpace: "pre",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "7.3px"
    },
    x: 681.571,
    y: 450.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweepCoin);
export default __webpack_public_path__ + "static/media/sweep-coin.795c3579aebdc9a89f4c0fe0b5dbe3d2.svg";
export { ForwardRef as ReactComponent };